import React from "react";
import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaLinkedinIn,
} from "react-icons/fa";
import whiteLogo from "../../assets/images/logo-white.svg";

const Footer = () => {
  return (
    <footer className="bg-[#4CAF50] text-white pt-12">
      {/* Top Section */}
      <div className="max-w-7xl mx-auto px-6 md:px-0 md:px-12 grid grid-cols-1 md:grid-cols-4 gap-10 pb-10 text-base">
        {/* Logo and Description */}
        <div>
          <img src={whiteLogo} alt="AgroLink Logo" className="h-12 mb-4" />
          <p className="mb-4 leading-relaxed">
            Connecting Nigeria’s agricultural value chain through secure,
            verified transactions with nationwide accessibility.
          </p>
          <div className="flex gap-4 text-white text-xl">
            <FaFacebookF />
            <FaTwitter />
            <FaInstagram />
            <FaLinkedinIn />
          </div>
        </div>

        {/* Quick Link */}
        <div>
          <h4 className="font-semibold mb-3 text-lg">Quick Link</h4>
          <ul className="space-y-2">
            <li>
              <a href="https" className="hover:underline">
                How It Works
              </a>
            </li>
            <li>
              <a href="https" className="hover:underline">
                About Us
              </a>
            </li>
            <li>
              <a href="htpps" className="hover:underline">
                Pricing
              </a>
            </li>
            <li>
              <a href="htpps" className="hover:underline">
                FAQ
              </a>
            </li>
          </ul>
        </div>

        {/* For Users */}
        <div>
          <h4 className="font-semibold mb-3 text-lg">For Users</h4>
          <ul className="space-y-2">
            <li>
              <a href="https" className="hover:underline">
                For Farmers
              </a>
            </li>
            <li>
              <a href="https" className="hover:underline">
                For Buyers
              </a>
            </li>
            <li>
              <a href="https" className="hover:underline">
                For Transporters
              </a>
            </li>
          </ul>
        </div>

        {/* Contact Us */}
        <div>
          <h4 className="font-semibold mb-3 text-lg">Contact Us</h4>
          <ul className="space-y-2">
            <li>support@agrolink.ng</li>
            <li>+234 800 AGRO-LINK</li>
            <li>Lagos, Nigeria</li>
            <li>Available in all 774 LGAs</li>
          </ul>
        </div>
      </div>

      {/* Bottom Section */}
      <div className="w-full border-t border-white/40 text-base py-4 px-6 md:px-40 flex flex-col md:flex-row justify-between items-center">
        <p className="mb-2 md:mb-0">
          © Copyright Farmport 2024. All rights reserved
        </p>
        <div className="flex gap-4">
          <a href="https" className="hover:underline">
            Privacy Policy
          </a>
          <a href="https" className="hover:underline">
            Terms of Service
          </a>
          <a href="https" className="hover:underline">
            Security
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
